import React, { Component } from 'react';
import classNames from 'classnames';
import { PaddedSection, Button } from '../../atoms';
import { OPTIMIZED_RESIZE } from '../../../utils/optimisedResize';

import './styles.css';

const UA = navigator.userAgent.toLowerCase();
const MQ_SMALL_SCREEN = '(max-width: 1199px)';

/**
 * A template for the hero section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {String} buttonLabel
 * @prop {String} heading
 * @prop {String} href
 * @prop {String} subheading
 * @prop {Number} startsCount
 * @prop {String} [className]
 * @prop {Object} [forwardedRef]
 *
 * @augments {Component<Props>}
 */
export default class Hero extends Component {

	state = {
		isSmallScreen: window.matchMedia(MQ_SMALL_SCREEN).matches,
		minHeight: Math.trunc(window.innerHeight),
		prevWidth: window.innerWidth,
		stars: Array.from(Array(this.props.startsCount), (_, index) => index + 1),
	};

	componentDidMount () {
		window.addEventListener(OPTIMIZED_RESIZE, this.setInnerHeight);
		this.mql = window.matchMedia(MQ_SMALL_SCREEN);
		this.mql.addListener(this.handleMediaChange);
		// this.updateStarts();
	}

	componentWillUnmount () {
		window.removeEventListener(OPTIMIZED_RESIZE, this.setInnerHeight);
	}

	updateStarts () {
		setInterval(() => {
			this.setState({ stars: Array.from(Array(this.props.startsCount), (_, index) => index + 1) });
		}, 3001);
	}

	genClassName = (props) => classNames('Hero', props.className);

	isMobileChrome = (/chrome/.test(UA) && /android/.test(UA)) || /crios/.test(UA);

	setInnerHeight = () => {
		// Don't update the height when the address bar shows/hides on Chrome.
		if (this.isMobileChrome && this.state.prevWidth === window.innerWidth) return;

		this.setState({
			minHeight: Math.trunc(window.innerHeight),
			prevWidth: window.innerWidth,
		});
	}

	handleMediaChange = ({ matches }) =>
		this.setState({
			isSmallScreen: !!matches,
		});

	renderStar = (index) => {
		const animationDelay = this.getRandomArbitrary(0, 9999).toFixed(2);
		return (<div key={index} style={{
			animationDelay: `${animationDelay}ms`,
			left: `calc(${this.getRandomArbitrary(0, window.innerWidth / 2)}px)`,
			top: `calc(${this.getRandomArbitrary(0, window.innerHeight / 2)}px)`,
		}} className='shooting_star'>
			<span style={{
				animationDelay: `${animationDelay}ms`,
			}} />
			<span style={{
				animationDelay: `${animationDelay}ms`,
			}} />
		</div>);
	}

	getRandomArbitrary = (min, max) => {
		return Math.random() * (max - min) + min;
	}

	render () {
		const { forwardedRef, heading, subheading, buttonLabel, href } = this.props;
		const className = this.genClassName(this.props);
		return (
			<PaddedSection
				className={className}
				forwardedRef={forwardedRef}
				style={{ minHeight: this.state.minHeight }}
			>
				{!this.state.isSmallScreen ? <div className='night'>
					{this.state.stars.map((_, index) => this.renderStar(index))}
				</div> : null }
				<h2>{subheading}</h2>
				<h1>{heading}</h1>

				<Button className='Hero-button Button-arrow-next' href={href}>
					<span>{buttonLabel}</span>
				</Button>
			</PaddedSection>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/templates/Hero/Hero.js